import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import styles from "./EditableQuestionAnswerForm.module.scss";
import AiInsightDiv from "../AiInsightDiv";
import PiiDetectionPanel from "../PiiDetectionPanel";

const EditableQuestionAnswerForm = ({
  questionFieldName,
  answerFieldName,
  questionValue,
  answerValue,
  label = "",
  questionPlaceholder = "Enter question",
  answerPlaceholder = "Enter answer",
  formik,
  onQuestionChange,
  onAnswerChange,
  onAnswerFocus,
  onAnswerBlur,
  onManualNudge,
  questionRows = 3,
  answerRows = 6,
  resize = "both",
  questionNo,
  onFeedback,
  feedbackState: parentFeedbackState,
  answerRef,
  answerPiiBlocked = false,
  answerPiiHits = [],
  onAnswerPiiOverride
}) => {
  const [localFeedbackState, setFeedbackState] = useState(null);

  const feedbackState = parentFeedbackState ?? localFeedbackState;

  const handleFeedback = type => {
    setFeedbackState(type);
    if (onFeedback) onFeedback(type);
  };
  return (
    <>
      <div className={styles.questionLabel}>{label}</div>
      <div className={styles.row}>
        {/* Question Field */}
        <div className={styles.questionRow}>
          <span className={styles.questionNo}>{`${questionNo}.`}</span>
          <div 
            className={styles.fieldWithInsight}
            ref={answerRef}
          >
            <TextField
              className={`${styles.textarea} ${styles.boldText}`}
              multiline
              minRows={questionRows}
              name={questionFieldName}
              inputProps={{ style: { resize } }}
              value={questionValue}
              placeholder={questionPlaceholder}
              variant="outlined"
              onChange={e => {
                if (onQuestionChange) onQuestionChange(e);
              }}
              error={
                formik?.touched?.[questionFieldName] &&
                Boolean(formik?.errors?.[questionFieldName])
              }
              helperText={
                formik?.touched?.[questionFieldName] &&
                formik?.errors?.[questionFieldName]
              }
            />
          </div>
        </div>

        {/* Answer Field */}
        <div className={styles.answerRow}>
          <div className={styles.answerSpacer} />
          <div 
            className={styles.fieldWithInsight}
            ref={answerRef}
          >
            <TextField
              className={styles.textarea}
              multiline
              minRows={answerRows}
              name={answerFieldName}
              inputProps={{ style: { resize } }}
              value={answerValue}
              placeholder={answerPlaceholder}
              variant="outlined"
              onChange={e => {
                if (onAnswerChange) onAnswerChange(e);
              }}
              onFocus={e => {
                if (onAnswerFocus) onAnswerFocus(e);
              }}
              onBlur={e => {
                if (onAnswerBlur) onAnswerBlur(e);
              }}
              error={
                (formik?.touched?.[answerFieldName] &&
                  Boolean(formik?.errors?.[answerFieldName])) ||
                answerPiiBlocked
              }
              helperText={
                !answerPiiBlocked &&
                formik?.touched?.[answerFieldName] &&
                formik?.errors?.[answerFieldName]
              }
            />
            {answerPiiBlocked && (
              <PiiDetectionPanel hits={answerPiiHits} onOverride={onAnswerPiiOverride} />
            )}
            <AiInsightDiv state={feedbackState} onClick={onManualNudge} />
          </div>
        </div>
      </div>
    </>
  );
};

export default EditableQuestionAnswerForm;
